import React from 'react';
import { useFetch } from 'hooks';
import { routes } from 'constants/config';
import { Spinner } from 'ui';
import InfoTooltip from 'components/shared/InfoTooltip';
import { escape } from 'lodash/fp';

const LessonGamificationPoints = () => {
  const { data, loading, error } = useFetch(
    routes.GAMIFICATION.POINTING_SYSTEM,
  );

  if (error) return <></>;

  if (loading || !data) {
    return (
      <div className="d-f ai-c jc-c mb-8">
        <Spinner />
      </div>
    );
  }

  return (
    <>
      <h3 className="Module-heading SectionHeading">
        {t('lesson_overview.gamification_points.title')}
        <InfoTooltip
          tooltip={t('lesson_overview.gamification_points.tooltip')}
          className="ml-4 tooltip-fixedWidth Module-headingIcon"
        />
      </h3>
      <div
        className="SidebarModule-padded"
        dangerouslySetInnerHTML={{
          __html: t('lesson_overview.gamification_points.lesson_points', {
            points: escape(data.learningContent?.completed?.assigned?.lesson),
          }),
        }}
      />
    </>
  );
};

export default props => <LessonGamificationPoints {...props} />;
